import { forwardRef, type Ref, type SVGProps } from "react";
const IconRedoFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M9.464 14.536a5 5 0 1 1 7.071-7.072l.006.006 4.6 4.53h-4.14a2 2 0 0 0 0 4h9a2 2 0 0 0 2-2V5a2 2 0 1 0-4 0v4.2l-4.643-4.57A9 9 0 0 0 6.634 17.36l.002.003 11.98 12.046a2 2 0 0 0 2.835-2.82L9.468 14.54z" />
  </svg>
);
const ForwardRef = forwardRef(IconRedoFilledSVG);
ForwardRef.displayName = "IconRedoFilled";
export { ForwardRef as IconRedoFilled };
